/**
 * API クライアントからのエラーをパース
 * @example
 * parseClientError(error.response);
 * => { code: "auth/invalid-email", detail: "メールアドレスの形式が正しくありません。" }
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseClientError = (error: any) => {
  const jsonString = JSON.stringify(error, null, 2);

  const regex = /"code":\s*"([^"]+)",\s*"detail":\s*"([^"]+)"/;
  const match = jsonString.match(regex);

  return {
    code: match ? match[1] : "",
    detail: match ? match[2] : "",
  };
};
